import Upgrade from './Upgrade.vue'

export default Upgrade
